// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"_30a7481","background":"_9f52cde","icon":"_a72abfc"};